import { computed } from 'vue';

export function useFileTypeIcon(fileType: string) {
  const mimeTypes = {
    word: [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
    excel: [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ],
    powerpoint: [
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ],
    image: [
      'image/jpeg',
      'image/png',
      'image/gif',
      'image/bmp',
      'image/webp',
      'image/svg+xml',
    ],
    pdf: ['application/pdf'],
    audio: ['audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/mp4', 'audio/aac'],
  };

  const fileIcon = computed(() => {
    if (mimeTypes.word.includes(fileType)) {
      return ['far', 'file-word'];
    }
    if (mimeTypes.excel.includes(fileType)) {
      return ['far', 'file-excel'];
    }
    if (mimeTypes.powerpoint.includes(fileType)) {
      return ['far', 'file-powerpoint'];
    }
    if (mimeTypes.image.includes(fileType)) {
      return ['far', 'image'];
    }
    if (mimeTypes.pdf.includes(fileType)) {
      return ['far', 'file-pdf'];
    }
    if (mimeTypes.audio.includes(fileType)) {
      return ['far', 'music'];
    }
    return ['far', 'file'];
  });

  return { fileIcon, mimeTypes };
}
